<template>

<component :is="(route) ? 'app-router' : 'div'" :to="{name: route, params: params}" class="item" :class="{'is-first': first, 'is-session': $route.meta.isSession, 'is-active': active}" :data-indent="indent" :data-gap="gap" v-on:click="onClick">

    <div class="item-icon" v-if="icon"><i class="fa-solid fa-fw" :class="'fa-' + icon"></i></div>
    <div class="item-indent" v-if="indent"></div>
    <div class="item-text">{{ text }}</div>
    <div class="item-count" v-if="count">{{ count | prettyNumber }}</div>
    <i class="item-caret fa-solid fa-caret-right" v-if="isToggle && !active" />
    <i class="item-caret fa-solid fa-caret-down" v-if="isToggle && active" />

</component>

</template>

<script>

export default {

    props: ['text', 'count', 'gap', 'active', 'isToggle', 'route', 'params', 'icon', 'first', 'indent'],

    methods: {

        onClick: function(e) {

            if(this.isToggle) {

                e.stopPropagation()
                e.preventDefault()

                this.$emit('click')
                
            }

        }

    }

}

</script>

<style scoped>

.item {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.item.is-active {
    border-bottom-color: transparent;
    background-color: #274F65;
}

.is-mobile .item {
    padding: 10px 20px;
}

.is-minimised .item {
    padding: 0px;
}

.is-desktop .item:hover:before {
    background-color: #366177;
    cursor: pointer;
    border-bottom-color: transparent;
    display: block;
    content: '';
    position: absolute;
    border-radius: 10px;
    left: 6px;
    top: 2px;
    right: 6px;
    bottom: 2px;
    z-index: -1;
}

.menu-child .item:hover:before {
    top: -2px;
    bottom: -2px;
}

.is-mobile .item[data-indent="3"] {
    padding: 7px 20px 7px 84px;
}

.item-icon {
    font-size: 16px;
    width: 24px;
    color: #fff;
    text-align: center;
    margin-right: 10px;
}

.is-minimised .item-icon {
    width: 48px;
    height: 48px;
    line-height: 48px;
    margin: 0px;
}

.item.router-link-active .item-icon {
    color: #f6c86c;
}

.item-text {
    color: #fff;
    font-size: 16px;
    letter-spacing: 1.5px;
    font-weight: 400;
    font-family: 'Roboto', sans-serif;
}

.is-mobile .item-text {
    font-size: 14px;
}

.is-minimised .item-text {
    display: none;
}

.item.router-link-active .item-text {
    color: #f6c86c;
}

.item-count {
    background-color: #26445b;
    border-radius: 4px;
    color: #fff;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -12px;
    height: 24px;
    font-weight: 400;
    min-width: 24px;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    padding: 0px 5px;
}

.is-mobile .item-count {
    right: 20px;
    font-size: 12px;
}

.is-minimised .item-count {
    display: none;
}

.item.router-link-exact-active .item-count {
    background-color: #f6c86c;
    color: #012b39;
}

.item-indent {
    display: none;
    height: 1px;
    width: 12px;
    background-color: #708895;
    margin: 0px 5px 0px 3px;
}

.item-indent:before {
    content: '';
    display: none;
    position: absolute;
    left: 0px;
    bottom: 1px;
    height: 32px;
    width: 1px;
    background-color: #708895;
}

.item[data-gap="0"] .item-indent:before {
    height: 16px;
}

.item[data-gap="1"] .item-indent:before {
    height: 64px;
}

.item[data-gap="2"] .item-indent:before {
    height: 96px;
}

.item[data-gap="3"] .item-indent:before {
    height: 128px;
}

.item[data-gap="4"] .item-indent:before {
    height: 160px;
}

.item[data-gap="5"] .item-indent:before {
    height: 192px;
}

.item[data-gap="6"] .item-indent:before {
    height: 224px;
}

.item[data-gap="7"] .item-indent:before {
    height: 256px;
}

.item[data-gap="8"] .item-indent:before {
    height: 288px;
}

.item[data-gap="9"] .item-indent:before {
    height: 320px;
}

.item[data-gap="10"] .item-indent:before {
    height: 352px;
}

.item.is-first .item-indent:before {
    height: 14px;
}

.item-caret {
    position: absolute;
    right: 20px;
    width: 24px;
    text-align: center;
    line-height: 24px;
    height: 24px;
    top: 50%;
    margin-top: -12px;
    font-size: 16px;
    color: #fff;
}

</style>
